import { isDefined } from "@clipboard-health/util-ts";
import { IonInput } from "@ionic/react";
import { Place } from "@src/app/address/types";
import { useEffect, useState } from "react";

import { getLocationFromPlace, parseAddressComponents } from "../helpers/googleMaps";

interface PlacesAutoCompleteProps {
  defaultValue: string;
  onChange: (place: Place) => void;
}

export function PlacesAutoComplete(props: PlacesAutoCompleteProps) {
  const { defaultValue, onChange } = props;
  const [inputElement, setInputElement] = useState<HTMLInputElement | undefined>();

  useEffect(() => {
    const mapApi = window.google?.maps;
    if (!isDefined(mapApi) || !isDefined(inputElement)) {
      return;
    }
    const mapAutoComplete: google.maps.places.Autocomplete = new mapApi.places.Autocomplete(
      inputElement
    );
    const mapAutoCompleteListener = mapAutoComplete.addListener("place_changed", () => {
      const place = mapAutoComplete.getPlace();

      if (!place.geometry) {
        return;
      }
      const location = getLocationFromPlace(place);
      const address = parseAddressComponents(place.address_components ?? []);
      address.formatted = place.formatted_address;
      onChange({ location, address });
    });
    return () => {
      mapAutoCompleteListener.remove();
    };
  }, [onChange, inputElement]);

  return (
    <IonInput
      debounce={1000}
      ref={async (ionicInput) => {
        /**
         * Move to MUI implementation.
         * Original comment about this:
         * Ionic's testing mocks don't provide support for IonInput.getInputElement yet
         */
        const inputElement = await ionicInput?.getInputElement?.();
        setInputElement(inputElement);
      }}
      clearInput={true}
      autofocus={!defaultValue}
      value={defaultValue}
      className="form-input"
      placeholder="Search for area, street name..."
    />
  );
}
